import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { openDialog } from "../../../store/actions";
import { isGovernorateEmperor } from "../../../lib/commonFunctions";
import { GovernyInfo } from "../../../lib/types";

interface IProps {
  elementRef: any;
}

const mapStateToProps = (state: any) => ({
  id: state.governorate.id,
  alliance: state.governorate.alliance,
  membershipApplication: state.governorate.membershipApplication
});

const mapDispatchToProps = (dispatch: any) => ({
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

const AllianceActions = ({
  id,
  alliance,
  membershipApplication,
  elementRef,
  openDialogDispatch
}: IProps & ConnectedProps<typeof connector>) => (
  <div className={"dialog-content"}>
    <table className="table">
      {alliance
        ? <tr>
            <td className={"no-border"}>
              <a
                href="#"
                onClick={() => openDialogDispatch({
                  header: "Leave alliance",
                  name: "LeaveAlliance",
                  clear: true,
                  emperor: isGovernorateEmperor(id, alliance),
                  last: alliance.members.length === 1,
                  marketItems: false,
                  members: isGovernorateEmperor(id, alliance)
                    ? alliance.members
                      .filter((m: GovernyInfo) => m.id !== id) : null,
                  elementRef
                })}
                className="btn btn-blank btn-no-width"
              >
                Leave
              </a>
            </td>
          </tr>
        : <>
            <tr>
              <td className={"no-border"}>
                Create new alliance and invite other players to join you&nbsp;
                or apply for membership in already existing one.
              </td>
            </tr>
            <tr>
              <td className={"no-border"}>
                <a
                  href="#"
                  onClick={() => openDialogDispatch({
                    header: "New alliance",
                    name: "FoundAlliance",
                    clear: true,
                    elementRef
                  })}
                  className="btn btn-blank btn-no-width"
                >
                  New alliance
                </a>
              </td>
            </tr>
            {!membershipApplication
              ? <tr>
              <td className={"no-border"}>
                <a
                  onClick={() => openDialogDispatch({
                    header: "Application",
                    name: "ApplyAlliance",
                    clear: true,
                    elementRef
                  })}
                  className="btn btn-blank btn-no-width"
                >
                  Application
                </a>
              </td>
            </tr> : <></>}
        </>
      }
    </table>
  </div>
)

export default connector(AllianceActions);
